import { EffectFade } from 'swiper/modules'
import { defaultPreset } from './default'

export const homeIntroPreset = {
  ...defaultPreset,
  modules: [...defaultPreset.modules, EffectFade],
  speed: 500,
  slidesPerView: 1,
  slidesPerGroup: 1,
  autoHeight: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
}
